import "../css/app.scss";

import {createApp} from "vue";
import App from "./App.vue";
import router from "./router";
import {createPinia} from "pinia";
import Spinner from "./components/Spinner.vue";
import Toast, {PluginOptions} from "vue-toastification";
import "vue-toastification/dist/index.css";
import Maska from "maska";
import {autoAnimatePlugin} from "@formkit/auto-animate/vue";
import * as Sentry from "@sentry/vue";
import {BrowserTracing} from "@sentry/tracing";

const app = createApp(App);

/**
 * Plugins
 */
app.use(createPinia());

/**
 * Dokładna konfiguracja:
 * @see https://github.com/Maronato/vue-toastification
 */
app.use(Toast, <PluginOptions>{
    position: "top-right",
    timeout: 5000,
    closeOnClick: true,
    pauseOnFocusLoss: true,
    pauseOnHover: true,
    draggable: true,
    draggablePercent: 0.6,
    showCloseButtonOnHover: true,
    hideProgressBar: false,
    closeButton: "button",
    icon: true,
    rtl: false,
    maxToasts: 7,
    newestOnTop: true,
    filterBeforeCreate: (toast, toasts) => {
        if (toasts.filter((t) => t.content === toast.content).length !== 0) {
            // Returning false discards the toast
            return false;
        }
        // You can modify the toast if you want
        return toast;
    },
});

/**
 * https://github.com/beholdr/maska
 */
app.use(Maska);

/**
 * Vue Auto Animate plugin
 * @see https://auto-animate.formkit.com
 */
app.use(autoAnimatePlugin);

import VERSION from "../../VERSION?raw";

/**
 * Sentry
 * @see https://docs.sentry.io/platforms/javascript/guides/vue/
 */
Sentry.init({
    app,
    // @ts-ignore
    dsn: import.meta.env.VITE_SENTRY_DSN,
    release: "odpis@" + VERSION,
    integrations: [
        new BrowserTracing({
            routingInstrumentation: Sentry.vueRouterInstrumentation(router),
            // @ts-ignore
            tracePropagationTargets: [import.meta.env.VITE_SENTRY_TRACE_PROPAGATION_TARGETS],
        }),
        new Sentry.Replay()
    ],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    // @ts-ignore
    tracesSampleRate: import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE,
    // @ts-ignore
    logErrors: import.meta.env.VITE_SENTRY_LOG_ERRORS,
    // This sets the sample rate to be 10%. You may want this to be 100% while
    // in development and sample at a lower rate in production
    // @ts-ignore
    replaysSessionSampleRate: import.meta.env.VITE_SENTRY_REPLAYS_SESSION_SAMPLE_RATE,
    // If the entire session is not sampled, use the below sample rate to sample
    // sessions when an error occurs.
    // @ts-ignore
    replaysOnErrorSampleRate: import.meta.env.VITE_SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE,
});

app.use(router);

app.component("spinner", Spinner); // Globalny komponent dostępny w całym projekcie

app.mount("#app");
